import { render, staticRenderFns } from "./ArrowHorizontal.vue?vue&type=template&id=61684e95"
import script from "./ArrowHorizontal.vue?vue&type=script&lang=js"
export * from "./ArrowHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports